import React from "react"
import {Tooltip} from "antd"
import {useTranslation} from "react-i18next"
import {AlignEdge} from "../utils/fieldLayout"
import styles from "./FieldAlignActions.module.css"

const ALIGN_ACTIONS: Array<{edge: AlignEdge; labelKey: string}> = [
    {edge: "left", labelKey: "tasks.alignLeft"},
    {edge: "center", labelKey: "tasks.alignCenter"},
    {edge: "right", labelKey: "tasks.alignRight"},
    {edge: "top", labelKey: "tasks.alignTop"},
    {edge: "middle", labelKey: "tasks.alignMiddle"},
    {edge: "bottom", labelKey: "tasks.alignBottom"}
]

type Props = {
    count: number
    onAlign: (edge: AlignEdge) => void
}

export function FieldAlignActions({count, onAlign}: Props) {
    const {t} = useTranslation(["tasks"])

    return (
        <div className={styles.bar} data-field-toolbar>
            <span className={styles.count}>{t("tasks.fieldsSelected", {count})}</span>
            <div className={styles.actions}>
                {ALIGN_ACTIONS.map((action) => (
                    <Tooltip key={action.edge} title={t(action.labelKey)}>
                        <button type="button" className={styles.action} onClick={() => onAlign(action.edge)}>
                            {renderAlignIcon(action.edge)}
                        </button>
                    </Tooltip>
                ))}
            </div>
        </div>
    )
}

const renderAlignIcon = (edge: AlignEdge) => {
    const path = {
        left: "M2 2v12M4 4h8M4 8h5M4 12h8",
        center: "M8 2v12M3 4h10M5 8h6M3 12h10",
        right: "M14 2v12M4 4h8M7 8h5M4 12h8",
        top: "M2 2h12M4 4v8M8 4v5M12 4v8",
        middle: "M2 8h12M4 3v10M8 5v6M12 3v10",
        bottom: "M2 14h12M4 4v8M8 7v5M12 4v8"
    }[edge]

    return (
        <svg width="24" height="24" viewBox="0 0 16 16" aria-hidden="true">
            <path d={path} fill="none" stroke="currentColor" strokeWidth="1.4" />
        </svg>
    )
}
